export default __webpack_public_path__ + "static/media/Leggings of the Howling Giant.65f74241.jpg";